import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router';
import { AppDataContext, VLink } from "../AppDataContext";
import useNetwork from '../../useNetwork';
import LoginAndRegistration from '../LoginAndRegistration';
import { Loader } from '../Loader';
import { Helmet } from "react-helmet";

export function Dashboard(props) {

    const context = useContext(AppDataContext);
    const { loading, networkError, netRequest, netRenderError } = useNetwork(true);
	const [invoices, setInvoices] = useState(null);
	const [schedules, setSchedules] = useState(null);

	function loadInvoices() {
		const getNextInvoices = async () => {
			const url = 'api/site/GetDashboard';

			const response = await netRequest(url);

			if (response.data != null) {
				setInvoices(response.data.pendingInvoices);
				setSchedules(response.data.pendingSchedules);
			}

		};
		getNextInvoices();
	}

	useEffect(() => {
		loadInvoices();
	}, []);


	const registerLoggedIn = (loginResponse) => {

	};

    //if (networkError) {
    //    //return netRenderError();
    //    if (networkError === "Unauthorized") {
    //        return <Redirect to="/login" />;
    //    }
    //    return <Redirect to="/error" status={networkError} />

    //}
    //if (loading)
    //    return <></>

    return (
		<>
			<Helmet>
				<title>My Account</title>
			</Helmet>
			<div class="modal fade" id="registerAuctionModal" tabindex="-1" aria-labelledby="registerAuctionModalLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
					<div class="modal-content">
						<div class="modal-header">
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>

						<div class="modal-body">
							<LoginAndRegistration
								showLogin={true}
								showSignup={true}
								registrationComplete={registerLoggedIn}
								showReadOnlyTerms={false}
							/>
						</div>
					</div>
				</div>
			</div>
			<div class="py-3">
				<div class="row">
					<div class="col-12 col-md-4 my-3">
						<div class="card">
							<div class="card-title p-3 pb-0 mb-0 text-center">
								Account Status
							</div>
							<div class="card-body text-center">
								{context.emailVerified ?
									<label className={"auction-label highest"}>
										Verified
									</label>
									:
									<VLink to="#" className={"alert-link auction-label invoices"} data-bs-toggle="modal" data-bs-target="#registerAuctionModal">
										Not Verified
									</VLink>
								}
							</div>
						</div>
					</div>
					<div class="col-12 col-md-4 my-3">
						<div class="card">
							<div class="card-title p-3 pb-0 mb-0 text-center">
								Schedules
							</div>
							<div class="card-body text-center">
								{schedules != null ?
									<VLink to="/dashboard/invoices" className={"alert-link auction-label " + (schedules.length > 0 ? "highest" : "pending")}>
										{schedules.length == 0 && "No "}
										Schedules
									</VLink>
									:
									<>&nbsp;</>
								}
							</div>
						</div>
					</div>
					<div class="col-12 col-md-4 my-3">
						<div class="card">
							<div class="card-title p-3 pb-0 mb-0 text-center">
								Invoices
							</div>
							<div class="card-body text-center">
								{invoices != null ?
									<VLink to="/dashboard/invoices" className={"alert-link auction-label " + (invoices.length > 0 ? "invoices" : "pending") }>
										{invoices.length == 0 && "No "}
										Pending Invoices
									</VLink>
									:
									<>&nbsp;</>
								}
							</div>
						</div>
					</div>
				</div>

			</div>

			<Loader loading={loading} />
		 

        </>
    );

}
